<div class="sprof">

  <header class="sprof__head">
    <h1 class="sprof__title">
      <i class="fa-solid fa-id-card"></i>
      {{ 'PROFILE.TITLE' | translate }}
    </h1>
  </header>

  <app-identity-banner
    [name]="displayName()"
    [avatar]="avatar()"
    kind="student"
    [learningPath]="student()?.learningPath?.title ?? null"></app-identity-banner>

  <!-- ─── Coordonnées ─────────────────────────────────────────── -->
  @if (student(); as s) {
    <section class="sprof__card">
      <h2 class="sprof__section">{{ 'PROFILE.DETAILS' | translate }}</h2>
      <dl class="sprof__facts">
        @if (s.studentCode) {
          <div><dt>{{ 'PROFILE.CODE' | translate }}</dt><dd>{{ s.studentCode }}</dd></div>
        }
        @if (s.email) {
          <div><dt>{{ 'PROFILE.EMAIL' | translate }}</dt><dd>{{ s.email }}</dd></div>
        }
        @if (s.birthDate) {
          <div><dt>{{ 'PROFILE.BIRTH_DATE' | translate }}</dt>
              <dd>{{ s.birthDate | date:'dd/MM/yyyy' }}</dd></div>
        }
      </dl>
    </section>
  }

  <!-- ─── Bulletins scolaires ─────────────────────────────────── -->
  <section class="sprof__card">
    <h2 class="sprof__section">
      <i class="fa-solid fa-file-lines"></i>
      {{ 'PROFILE.REPORT_CARDS.TITLE' | translate }}
    </h2>
    <p class="sprof__hint">{{ 'PROFILE.REPORT_CARDS.HINT' | translate }}</p>

    <!-- Dépôt -->
    <div class="sprof__upload">
      <div class="sprof__field">
        <label for="rc-file">{{ 'PROFILE.REPORT_CARDS.FILE' | translate }} *</label>
        <input id="rc-file" type="file" (change)="onFileChange($event)"
               accept=".pdf,.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx">
        @if (selectedFile) {
          <small class="sprof__file">{{ selectedFile.name }}</small>
        }
      </div>

      <div class="sprof__field">
        <label for="rc-title">{{ 'PROFILE.REPORT_CARDS.LABEL' | translate }} *</label>
        <input id="rc-title" type="text" [(ngModel)]="title"
               [placeholder]="'PROFILE.REPORT_CARDS.LABEL_PLACEHOLDER' | translate">
      </div>

      <div class="sprof__field">
        <label for="rc-date">{{ 'PROFILE.REPORT_CARDS.DATE' | translate }}</label>
        <input id="rc-date" type="date" [(ngModel)]="documentDate">
      </div>

      <button type="button" class="sprof__btn" [disabled]="!canSubmit" (click)="submit()">
        @if (uploading()) { <span class="sprof__spinner"></span> }
        <i class="fa-solid fa-cloud-arrow-up"></i>
        {{ 'PROFILE.REPORT_CARDS.SUBMIT' | translate }}
      </button>
    </div>

    @if (uploadError()) {
      <p class="sprof__error">
        <i class="fa-solid fa-circle-exclamation"></i>
        {{ uploadError()! | translate }}
      </p>
    }

    <!-- Liste -->
    @if (errored()) {
      <!-- Erreur de chargement : jamais de bulletins de substitution -->
      <app-error-state titleKey="PROFILE.REPORT_CARDS.ERROR_TITLE"
                       messageKey="PROFILE.REPORT_CARDS.ERROR_DESC"
                       (retry)="reload()"></app-error-state>
    } @else if (loading()) {
      <p class="sprof__hint">{{ 'LOADINGS.LOADING' | translate }}</p>
    } @else if (documents().length === 0) {
      <div class="sprof__empty">
        <i class="fa-regular fa-folder-open"></i>
        <p>{{ 'PROFILE.REPORT_CARDS.EMPTY' | translate }}</p>
      </div>
    } @else {
      <ul class="sprof__docs">
        @for (d of documents(); track d.id) {
          <li class="sprof__doc">
            <i class="fa-solid fa-file-lines sprof__doc-icon"></i>
            <span class="sprof__doc-body">
              <span class="sprof__doc-title">{{ d.title }}</span>
              <span class="sprof__doc-meta">
                {{ d.uploadedAt | date:'dd/MM/yyyy' }}
                @if (sizeLabel(d.fileSizeBytes)) { · {{ sizeLabel(d.fileSizeBytes) }} }
              </span>
            </span>
          </li>
        }
      </ul>
    }
  </section>

</div>
